import { ApolloProvider } from '@apollo/client';
import * as Sentry from '@sentry/react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { client } from 'lib/apollo';
import React from 'react';
import { createRoot } from 'react-dom/client';

import './assets/styles/index.scss';
import App from './App';
import { ClientProvider } from './contexts/ClientContext';
import reportWebVitals from './reportWebVitals';

// Initialize dayjs plugins before app renders
dayjs.extend(customParseFormat);

Sentry.init({
    dsn: 'https://5c86e02d667b78bf96d401d5a8222299@o954610.ingest.us.sentry.io/4508002725789696',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost'],
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    <React.StrictMode>
        <ApolloProvider client={client}>
            <ClientProvider>
                <App />
            </ClientProvider>
        </ApolloProvider>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
